<div class='TabGroup'>
  <mat-tab-group #tabGroup class='TabGroup' (selectedTabChange)="onTopTabGroupChanged($event)" >


    <mat-tab  >
      <ng-template mat-tab-label>
        <span>Kontakte</span>
        @if (globserv.kontakt!=undefined) {
          <span>&nbsp;({{this.globserv.kontakt.Bexio.nr}})</span>
        }
      </ng-template>
      <div class="PasuraTabContent" >
        <app-kontakte style="width:900px">Loading..</app-kontakte>
      </div>
    </mat-tab>

    <!-- Tab Policen  Suche -------------------------------- -->
    <mat-tab >

      <ng-template mat-tab-label>
        <span>Policen</span>
        @if (this.globserv.policen!=undefined && globserv.policen.length>0) {
          <span>&nbsp;({{this.globserv.policen[0].PolicenNr}})</span>
        }
      </ng-template>
      <div class="PasuraTabContent" >
        <mat-expansion-panel #panSearchPolice class='pasuraMat1 mat-elevation-z4'  style='margin-top:20px; min-width: 800px;'   [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="flex-center" >
              Suche Police
            </mat-panel-title>


          </mat-expansion-panel-header>

          <div>
            <mat-form-field class="flex-center" >
              <!-- <mat-label>Suche (Policen-Nr / Pferd)</mat-label> -->
              <input class="flex-center" placeholder="Suche (Policen-Nr / Pferd)" matInput [(ngModel)]="SuchTextPol"  name="SuchePol" type="text">
            </mat-form-field>
          </div>
          <button mat-flat-button [disabled]="SuchTextPol.length<1"	color="primary"(click)="doSearchPolicen()" style="width: 100%">Suchen</button>

          <!-- Tab Policen Sucher Ergebnis -------------------------------- -->
          @if (findPolicen!=undefined  && findPolicen.length>0) {
            <div class='tabContacts'>
              <mat-table  #tabFindPol [dataSource]='findPolicen' multiTemplateDataRows >
                <ng-container matColumnDef="PolicenNr">
                  <mat-header-cell style=" min-width:120px"  *matHeaderCellDef >PolicenNr</mat-header-cell>
                  <mat-cell style=" min-width:120px" *matCellDef="let element">{{element.PolicenNr}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="Name">
                  <mat-header-cell *matHeaderCellDef>Versicherungsnehmer</mat-header-cell>
                  <mat-cell *matCellDef="let element">{{element.VN_Name}}, {{element.Ort}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Pferde">
                  <mat-header-cell *matHeaderCellDef>Pferde</mat-header-cell>
                  <div>
                    <mat-cell *matCellDef="let element" [ngClass]="element.Pferde.length>1?'cellBlockListPferde':''" >
                      @for (pferd of element.Pferde; track pferd; let i = $index) {
                        <div>
                          {{pferd.Pferd}}
                        </div>
                      }
                    </mat-cell>
                  </div>
                </ng-container>
                <mat-header-row table *matHeaderRowDef="displColFindPolNr"></mat-header-row>
			 						<mat-row *matRowDef="let row; 
			 							columns: displColFindPolNr;"
                  (click)="selectPolice(row)"
                  class='TabRow'
                  [ngClass]="{hovered: row.hovered}"
                  (mouseover)="row.hovered = true"
                  (mouseout)="row.hovered = false">
                </mat-row>
              </mat-table>
            </div>
          }

          <!-- Police -------------------------------- -->
        </mat-expansion-panel >

        @if (this.globserv.policen!=undefined && this.globserv.policen.length>0 && this.globserv.policen[0].PolicenNr!=undefined && panelPferdeShow) {
          <div>
            @for (police of this.globserv.policen; track police; let polIDX = $index) {
              <mat-expansion-panel  class='pasuraMat1 mat-elevation-z4'  style='min-width: 800px;' [expanded]="true" >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Police {{police.PolicenNr}}
                  </mat-panel-title>
                  <mat-panel-description>Pasura Pferdeversicherung</mat-panel-description>
                </mat-expansion-panel-header>
                <!-- Police Daten fix -------------------------------- -->
                @if (!police.edit) {
                  <div>
                    <mat-menu #subMenuPDF="matMenu">
                      <button mat-menu-item  (click)="getPolicePDF('')" >
                        <span>Police lang</span>
                      </button>
                      <button mat-menu-item  (click)="getPolicePDF('kurz')" >
                        <span>Police kurz</span>
                      </button>
                    </mat-menu>
                    <mat-grid-list cols="3" rowHeight="20px" >
                      <mat-grid-tile><div class="gridContentLeft">Versicherungsnehmer:</div></mat-grid-tile>
                      <mat-grid-tile ><div class="gridContentLeft"  >{{police.VN.Bexio.nr}} {{police.VN.Bexio.name_1}} {{police.VN.Bexio.name_2}}</div></mat-grid-tile>
                      <mat-grid-tile rowspan="3" style="float: right; text-align: right;">
                        <div class="menuPDF">
                          @if (pferdEdit!=true) {
                            <button  mat-button   (click)="toggelEditPol(polIDX)">
                              <mat-icon >edit</mat-icon>
                            </button>
                          }
                          @if (calcOK() && police.Pferde.length>0) {
                            <button   style="margin-top: -10px; width: 60px; align:right;"  mat-menu-item  [matMenuTriggerFor]="subMenuPDF" >
                              <mat-icon >picture_as_pdf</mat-icon>
                            </button>
                          }
                          @if (police.Pferde.length<=0) {
                            <button  mat-button   (click)="deletePolice(polIDX)">
                              <mat-icon >delete</mat-icon>
                            </button>
                          }
                        </div>
                      </mat-grid-tile>
                      @if (police.VN_Nr!=police.PZ_Nr) {
                        <mat-grid-tile><div class="gridContentLeft">Prämienzahler:</div></mat-grid-tile>
                      }
                      @if (police.VN_Nr!=police.PZ_Nr) {
                        <mat-grid-tile colspan="3"><div class="gridContentLeft"  >{{police.PZ.Bexio.nr}} {{police.PZ.Bexio.name_1}} {{police.PZ.Bexio.name_2}}</div></mat-grid-tile>
                      }
                      <mat-grid-tile><div class="gridContentLeft">Zahlweise:</div></mat-grid-tile>
                      <mat-grid-tile ><div class="gridContentLeft">{{getZahlweiseText(police.Zahlweise)}}</div></mat-grid-tile>
                      <mat-grid-tile><div class="gridContentLeft">Status:</div></mat-grid-tile>
                      <mat-grid-tile ><div class="gridContentLeft">{{police.Status}}</div></mat-grid-tile>
                      @if (police.FlottenRabatt!=undefined && police.FlottenRabatt>0) {
                        <div>
                          <mat-grid-tile ><div class="gridContentLeft">Rabatt:</div></mat-grid-tile>
                          <mat-grid-tile ><div class="gridContentLeft">{{police.FlottenRabatt}}%</div></mat-grid-tile>
                        </div>
                      }
                    </mat-grid-list>
                  </div>
                }
                <!-- Police Daten edit -------------------------------- -->
                @if (police.edit) {
                  <div>
                    <mat-grid-list cols="5" rowHeight="40px" >
                      <mat-grid-tile><div class="gridContentLeft">Versicherungsnehmer:</div></mat-grid-tile>
                      <mat-grid-tile colspan="4">
                        <div class="gridContentLeft"  >
                          <input placeholder="Versicherungsnehmer" [(ngModel)]="police.VN_Nr" type="number"  name="VN" style="width: 70px; margin-right: 30px;">
                          @if ((police.VN_Nr!= policen_org[polIDX]?.VN_Nr)) {
                            <button mat-button   (click)="getContact(police.VN_Nr,'VN', polIDX)" >
                              <mat-icon >search</mat-icon>
                            </button>
                          }
                          <span  >{{police.VN.Bexio.nr}} {{police.VN.Bexio.name_1}} {{police.VN.Bexio.name_2}}</span>
                        </div>
                      </mat-grid-tile>
                      <mat-grid-tile><div class="gridContentLeft">Prämienzahler:</div></mat-grid-tile>
                      <mat-grid-tile colspan="4">
                        <div class="gridContentLeft"  >
                          <input placeholder="Versicherungsnehmer" [(ngModel)]="police.PZ_Nr" type="number"  name="PZ" style="width: 70px; margin-right: 30px;">
                          @if ((police.PZ_Nr!= policen_org[polIDX]?.PZ_Nr)) {
                            <button mat-button   (click)="getContact(police.PZ_Nr,'PZ', polIDX)" >
                              <mat-icon >search</mat-icon>
                            </button>
                          }
                          <span  >{{police.PZ.Bexio.nr}} {{police.PZ.Bexio.name_1}} {{police.PZ.Bexio.name_2}}</span>
                        </div></mat-grid-tile>
                        <mat-grid-tile><div class="gridContentLeft">Zahlweise:</div></mat-grid-tile>
                        <mat-grid-tile colspan="4">
                          <div class="gridContentLeft">
                            <mat-chip-list aria-label="Zahlweise">
                              <mat-chip-option (click)="police.Zahlweise=1" [selected]="police.Zahlweise==1" [selectable]="police.Zahlweise!=1" >jährlich</mat-chip-option> &nbsp;
                              <mat-chip-option (click)="police.Zahlweise=2" [selected]="police.Zahlweise==2" [selectable]="police.Zahlweise!=2">halbjährlich</mat-chip-option>&nbsp;
                              <mat-chip-option (click)="police.Zahlweise=4" [selected]="police.Zahlweise==4" [selectable]="police.Zahlweise!=4">vierteljährlich</mat-chip-option>&nbsp;
                              <mat-chip-option (click)="police.Zahlweise=12" [selected]="police.Zahlweise==12" [selectable]="police.Zahlweise!=12">monatlich</mat-chip-option>
                            </mat-chip-list>
                          </div>
                        </mat-grid-tile>
                        <mat-grid-tile><div class="gridContentLeft">Status:</div></mat-grid-tile>
                        <mat-grid-tile colspan="4"><div class="gridContentLeft">{{police.Status}}</div></mat-grid-tile>
                        <mat-grid-tile><div class="gridContentLeft">Rabatt:</div></mat-grid-tile>
                        <mat-grid-tile colspan="4"><div class="gridContentLeft">
                          <mat-checkbox
                            [(ngModel)]="police.FlottenRabattAuto"
                            [color]="blue"
                          >automatisch</mat-checkbox>
                        </div></mat-grid-tile>
                        @if (police.FlottenRabatt!=undefined && police.FlottenRabattAuto!=1) {
                          <div>
                            <mat-grid-tile ><div class="gridContentLeft">Rabatt:</div></mat-grid-tile>
                            <mat-grid-tile ><div class="gridContentLeft">{{police.FlottenRabatt}}%</div></mat-grid-tile>
                          </div>
                        }
                      </mat-grid-list>
                      <mat-divider style='margin-bottom:20px; margin-Top: 10px;'></mat-divider>
                      <div style="text-align:center;">
                        <button mat-flat-button color="primary"(click)="resetPolicen()" >abbrechen</button>
                        &nbsp;
                        <button mat-flat-button [disabled]="!changedPolicen(polIDX)"	color="primary"(click)="savePolice(polIDX)" style="margin-left: 30px;" >speichern</button>
                      </div>
                    </div>
                  }
                  @if (progressSpinner) {
                    <div  class='flex-center'>
                      <mat-spinner  [diameter]="150" ></mat-spinner>
                    </div>
                  }
                  @if (!progressSpinner) {
                    <div >
                      <!-- Police-Zeile (Pferde-Tabelle - Edit) -------------------------------- -->
                      <app-versicherung-pferd [pferd]="pferd" [police]="police" >Loading...</app-versicherung-pferd>
                      <!-- Police-Zeile (Pferde-Tabelle) -------------------------------- -->
                      @if ((!police.edit) && pferdEdit!=true) {
                        <div class="tabPferde">
                          <mat-divider style="margin-bottom:20px; margin-Top: 10px;"></mat-divider>
                          <mat-table  #tablePferde
                            [dataSource]='this.globserv.policen[polIDX].Pferde' [multiTemplateDataRows]="true"
                            class="mat-elevation-z8">
                            @for (column of displColPferde; track column) {
                              <ng-container matColumnDef="{{column}}">
                                <mat-header-cell *matHeaderCellDef> {{column}} </mat-header-cell>
                                <mat-cell *matCellDef="let element"> {{getPerdListeItem(element,column)}} </mat-cell>
                              </ng-container>
                            }
                            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                            <ng-container matColumnDef="expandedDetail" >
                              <mat-cell *matCellDef="let element; index as pferdIDX" [attr.colspan]="displColPferde.length" class="row_selected">
                                <div class="tabPferdeDetailsTab" style="margin-top: 10px; margin-bottom: 10px;">
                                  <mat-grid-list cols="3" rowHeight="20px" >
                                    <mat-grid-tile><div class="gridContentLeft">Versicherung Beginn:</div></mat-grid-tile>
                                    <mat-grid-tile colspan="1"> <div class="DatenBetrag">{{getDatumCH(element.V_Beginn)}}</div></mat-grid-tile>
                                    <mat-grid-tile rowspan="3" class="gridContentRight">
                                      @if (element.Abgegangen==false) {
                                        <div  class="gridContentRight" >
                                          <button mat-button   (click)="editPferd(polIDX,element.ID)">
                                            <mat-icon >edit</mat-icon>
                                          </button>
                                          @if (calcOK()) {
                                            <button mat-button  style="margin-top: -10px"  (click)="getPolicePDF(element.ID)" >
                                              <mat-icon >picture_as_pdf</mat-icon>
                                            </button>
                                          }
                                        </div>
                                      }
                                      @if (element.Abgegangen==true) {
                                        <div  class="gridContentRight" >
                                          <button mat-button  (click)="restoreVersicherungPferd(polIDX, element.ID)"  matTooltip="Versicherung wieder aktivieren" >
                                            <mat-icon >restore</mat-icon>
                                          </button>
                                          @if (calcOK()) {
                                            <button mat-button  style="margin-top: -10px"  (click)="getPolicePDF(element.ID)" >
                                              <mat-icon >picture_as_pdf</mat-icon>
                                            </button>
                                          }
                                        </div>
                                      }
                                    </mat-grid-tile>
                                    @if (isDate(element.V_Ende)) {
                                      <div  class="gridContentLeft">
                                        <mat-grid-tile><div class="gridContentLeft">Versicherung Ende:</div></mat-grid-tile>
                                        <mat-grid-tile colspan="1"><div class="DatenBetrag"  >{{getDatumCH(element.V_Ende)}} </div></mat-grid-tile>
                                      </div>
                                    }
                                    @if (isDate(element.V_Ende)==false && element.V_Ende.length>0) {
                                      <div class="gridContentLeft">
                                        <mat-grid-tile><div class="gridContentLeft">Versicherung Ende:</div></mat-grid-tile>
                                        <mat-grid-tile colspan="1"><div class="DatenBetrag"  >{{getDatumCH(element.V_Ende)}} </div></mat-grid-tile>
                                      </div>
                                    }
                                    @if (element.V_Ende.length==0) {
                                      <div class="gridContentLeft">
                                        <mat-grid-tile><div class="gridContentLeft">Versicherung Ende:</div></mat-grid-tile>
                                        <mat-grid-tile colspan="1"><div class="DatenBetrag">laufend</div></mat-grid-tile>
                                      </div>
                                    }
                                    @if (element.Grund.length>0) {
                                      <div class="gridContentLeft">
                                        <mat-grid-tile><div class="gridContentLeft">Grund:</div></mat-grid-tile>
                                        <mat-grid-tile colspan="1"><div  class="DatenBetrag" >{{element.Grund}}</div></mat-grid-tile>
                                      </div>
                                    }
                                    <mat-grid-tile><div class="gridContentLeft">Alter (per {{element.Praemien.VBeginn}}):</div></mat-grid-tile>
                                    <mat-grid-tile colspan="1"><div class="DatenBetrag">{{element.Praemien.AlterText}}</div></mat-grid-tile>
                                    @if (element.Grund.length>0) {
                                      <div class="gridContentLeft">
                                        <mat-grid-tile colspan="1"><div ></div></mat-grid-tile>
                                      </div>
                                    }
                                    <mat-grid-tile colspan="1"><div class="gridContentLeft">Versicherungssumme:</div></mat-grid-tile>
                                    <mat-grid-tile colspan="1"><div class="DatenBetrag">{{globserv.formatMoney(element.VS)}}</div></mat-grid-tile>
                                    <mat-grid-tile colspan="1"><div ></div></mat-grid-tile>
                                    @for (hv of globserv.getHauptPositionen(element.Praemien); track hv) {
                                      <div >
                                        <mat-grid-tile><div class="gridContentLeft">{{hv.MarketingName}}:</div></mat-grid-tile>
                                        <mat-grid-tile colspan="1"><div class="DatenBetrag">{{globserv.formatMoney(hv.Netto)}}</div></mat-grid-tile>
                                        <mat-grid-tile colspan="1"><div ></div></mat-grid-tile>
                                        @if (hv.Selbstbehalt!=undefined) {
                                          <div >
                                            <mat-grid-tile><div class="gridContentLeft">Selbstbehalt:</div></mat-grid-tile>
                                            <mat-grid-tile colspan="1"><div class="DatenBetrag">{{globserv.formatMoney(hv.Selbstbehalt)}}</div></mat-grid-tile>
                                            <mat-grid-tile colspan="1"><div ></div></mat-grid-tile>
                                          </div>
                                        }
                                      </div>
                                    }
                                    @for (opt of globserv.getOptionen(element.Praemien); track opt) {
                                      <div >
                                        <mat-grid-tile><div class="gridContentLeft">{{opt.MarketingName}}:</div></mat-grid-tile>
                                        <mat-grid-tile colspan="1"><div class="DatenBetrag">{{globserv.formatMoney(opt.Netto)}}</div></mat-grid-tile>
                                        <mat-grid-tile colspan="1"><div ></div></mat-grid-tile>
                                      </div>
                                    }
                                    <mat-grid-tile><div class="gridContentLeft">Total Jahresprämie:</div></mat-grid-tile>
                                    <mat-grid-tile colspan="1"><div class="DatenBetrag">{{globserv.formatMoney(element.Praemien.PraemieTotal)}}</div></mat-grid-tile>
                                    <mat-grid-tile colspan="1"><div ></div></mat-grid-tile>
                                  </mat-grid-list>
                                  @if (element.ErstRechnung==true) {
                                    <button
                                      mat-flat-button	color="primary"(click)="makeErstRechnung(element)" style="width: 100%; margin-top: 10px;">
                                      @if (element.ErstRechnungBexioID!=undefine && element.ErstRechnungBexioID>0) {
                                        <span>Erstrechnung ({{element.ErstRechnungBexioID}})</span>
                                      }
                                      @if (!(element.ErstRechnungBexioID!=undefine && element.ErstRechnungBexioID>0)) {
                                        <span>Erstrechnung</span>
                                      }
                                    </button>
                                  }
                                  @if (element.ErstRechnung==false && anzFP_GJ==0 && element.Abgegangen==false) {
                                    <button
                                      mat-flat-button	color="primary"(click)="remakeFPRechnung(element,polIDX)" style="width: 100%; margin-top: 10px;">
                                      @if (element.ErstRechnungBexioID!=undefine && element.ErstRechnungBexioID>0) {
                                        <span>Folgeprämie ({{element.ErstRechnungBexioID}})</span>
                                      }
                                      @if (!(element.ErstRechnungBexioID!=undefine && element.ErstRechnungBexioID>0)) {
                                        <span>Folgeprämie neu ertellen für {{globserv.RGJahr}} </span>
                                      }
                                    </button>
                                  }
                                </div>
                              </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displColPferde"   > </mat-header-row>
				 				<mat-row *matRowDef="let row; 
				 					columns: displColPferde;"
                              class="TabRow"
                              [class.PferdAbgegangen]= "row.Abgegangen"
                              [class.row_selected]="tabPferdExpID == row.ID"
                              (click)="tabPferdExpID = (tabPferdExpID == row.ID ? -1 : row.ID)"
                              [ngClass]="{hovered: row.hovered}"
                              (mouseover)="row.hovered = true"
                              (mouseout)="row.hovered = false">
                            </mat-row>
				 				<mat-row *matRowDef="let row;
				 								columns: ['expandedDetail']"  
                              class='tabPferd-detail-row'
                              [@detailExpand]="row.ID == tabPferdExpID ? 'expanded' : 'collapsed'">
                            </mat-row>
                          </mat-table>
                        </div>
                      }
                      <!-- rechnungen -->
                      @if ((!police.edit) && pferdEdit!=true) {
                        <div class="tabRechnungen">
                          <mat-expansion-panel #panRechnungen class='pasuraMat1 mat-elevation-z4'  style='margin-top:20px; min-width: 800px;'  [expanded]="rgTabExpand" (opened)="loadRechnungen(polIDX)" (closed)="rgTabExpand=true">
                            <mat-expansion-panel-header>
                              <mat-panel-title>Rechnungen</mat-panel-title>
                              <mat-panel-description>
                                @if (loadRGSpinner===true) {
                                  <mat-spinner [diameter]="30" ></mat-spinner>
                                }
                              </mat-panel-description>
                            </mat-expansion-panel-header>
                            <mat-divider style="margin-bottom:20px; margin-Top: 10px;"></mat-divider>
                            <mat-table  #tableRechnungen
                              [dataSource]='police.Rechnungen' [multiTemplateDataRows]="true"
                              class="mat-elevation-z8">
                              @for (column of displColRechnungen; track column) {
                                <ng-container matColumnDef="{{column}}">
                                  <mat-header-cell style="white-space: nowrap; min-width:50px"   *matHeaderCellDef> {{column}} </mat-header-cell>
                                  <mat-cell style="white-space: nowrap; min-width:50px; font-size:12px"  *matCellDef="let element"> {{element[column]}} </mat-cell>
                                </ng-container>
                              }
                              <ng-container matColumnDef="PDF" >
                                <mat-header-cell *matHeaderCellDef>PDF</mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                  <button mat-button  (click)="getRechnungPDF(element.RechnungID)" >
                                    <mat-icon >picture_as_pdf</mat-icon>
                                  </button>
                                  <mat-menu #menuRG="matMenu">
                                    @if (element.StatusID==7) {
                                      <button mat-menu-item (click)="doRGReNew(element)" >
                                        <span>Rechnung neu erstellen</span>
                                      </button>
                                    }
                                    @if (element.StatusID==7 || element.StatusID==99) {
                                      <button mat-menu-item (click)="doRGDelete(element, polIDX)" >
                                        <span>Rechnung löschen</span>
                                      </button>
                                    }
                                    @if (element.StatusID==8) {
                                      <button mat-menu-item (click)="doRGEntwurf(element)" >
                                        <span>Rechnung in Entwurf stellen</span>
                                      </button>
                                    }
                                  </mat-menu>
                                  @if (element.Jahr>=globserv.RGJahr && (element.StatusID<9 || element.StatusID==99) && (!element.Titel.startsWith('EP'))) {
                                    <div>
                                      <button   mat-icon-button [matMenuTriggerFor]="menuRG" >
                                        <mat-icon>more_vert</mat-icon>
                                      </button>
                                    </div>
                                  }
                                </mat-cell>
                              </ng-container>
                              <mat-header-row *matHeaderRowDef="displColRechnungen2" > </mat-header-row>
				 				<mat-row *matRowDef="let row; 
				 					columns: displColRechnungen2;"
                                class="TabRow"
                                [ngClass]="{hovered: row.hovered}"
                                (mouseover)="row.hovered = true"
                                (mouseout)="row.hovered = false"
                                >
                              </mat-row>
                            </mat-table>
                          </mat-expansion-panel>
                        </div>
                      }
                    </div>
                  }
                </mat-expansion-panel>
              }
            </div>
          }
        </div>


      </mat-tab>

      <mat-tab label={{getTitelSchadenfaelle()}}  >
        <div class="PasuraTabContent" >
          <app-schadenfaelle >Loading..</app-schadenfaelle>
        </div>
      </mat-tab>

      <mat-tab label="Anträge">
        <div class="PasuraTabContent" >
          <app-antraege (openPolice)="openPolice($event)" [kontakt]="globserv.kontakt" >Loading..</app-antraege>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>